<template functional>
  <v-tooltip
    top
    z-index="101"
    max-width="300"
    :disabled="!props.delivery.date"
    :class="[data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]"
    content-class="appointment-tooltip"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <template slot="activator">
      <slot />
    </template>
    <div>指定者：{{ props.delivery.name }}</div>
    <div v-if="props.includeDate">
      指定日：
      <span :class="{past: props.delivery.status < 0}">
        {{ props.delivery.date }}
      </span>
    </div>
    <div>理由：{{ props.delivery.reason }}</div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'DeliveryToolTip',
  props: {
    delivery: {
      type: Object,
      default: () => {}
    },
    includeDate: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  font-size: 0.9rem;
}
.past {
  color: red;
}
</style>

<style lang="scss">
.appointment-tooltip {
  border-radius: 5px;
  text-align: left;
}
</style>
